<template>

  <div class="status-bar">
    <p class="title">
      {{ formatPercentageFinanced(object) }} financiado
    </p>
    <div class="progress-container">
      <div class="progress-bar">
        <span class="bar" :style="`width: ${object.funded_percentage}%`"></span>
      </div>
    </div>
  </div>

</template>

<script>

export default {
  name: 'ProgressBar',
  props: { object: Object },
  data () {
    return {
      minFinanced: 1000,
      minFundedPercentage: 99
    }
  },
  methods: {
    formatPercentageFinanced: function (opportunity) {
      if (opportunity.funded_percentage > this.minFundedPercentage) {
        if ((opportunity.amount_requested - opportunity.amount_financed) >= this.minFinanced) {
          return `${parseFloat(Math.floor(opportunity.funded_percentage))}%`
        }
      }
      return `${parseFloat(opportunity.funded_percentage).toFixed()}%`
    }
  }
}
</script>

<style scoped lang="scss">

.status-bar {

  .title {
    margin-bottom: 0;
    font-size: 1em;
    color: #666;
    text-align: center;
  }
}

.timeago {
  margin: .3rem 0;
  font-size: .8em;
  text-align: center;

  &:first-letter {
    text-transform: uppercase;
  }
}

.progress-container {
  $h: 10px;

  padding: .4rem .6rem;

  .progress-bar {
    position: relative;
    height: $h;
    border-radius: 5px;
    background-color: #efefef;
    border-bottom: 1px solid #ccc;
    overflow: hidden;

    .bar {
      position: absolute;
      top: 0;
      left: 0;
      display: inline-block;
      width: 50%;
      height: $h;
      background: #01b276;
      background: linear-gradient(to right, #01b276 0%,#03738b 100%);
    }
  }
}

</style>



// WEBPACK FOOTER //
// src/components/ProgressBar.vue